import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector, toObservable, nextToPromise, createSelectorRx, firstMap } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import * as rx from "rxjs";

interface Props {
    value: number;
    onChange: (x: number) => void;
}

/**Textbox para el código postal que muestra información del mismo */
export class CodPostal extends React.PureComponent<Props> {
    value = (x: Props) => x.value;
    infoCPErr = createSelectorRx(this.value, x => observeResource(resources.Colonia.ObtenerCodPostalInfo, x));
    infoCP = createSelector(this.infoCPErr, x => x.catch( () => []));

    descripcion = createSelectorRx(this.infoCP, x => firstMap(x.Colonias, x => true, x => x.Descripcion));

    render() {
        const descripcion = this.descripcion(this.props);
        return (
            <div style={{ display: "flex" }} >
                <div style={{ flex: "0 1 auto", width: "80px" }}>
                    <kea.Number value={this.props.value} onChange={this.props.onChange} style={{fontFamily: "monospace"}} />
                </div>
                <div style={{ flex: "1 0 0", fontSize: "10px" }}>
                    <kea.Text readonly={true} value={descripcion}  />
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/componentes/codpostal.tsx